import type { RouteComponent } from "vue-router";
import { privateRoutes } from "./private-routes";
import { publicRoutes } from "./public-routes";
import PageNotFound from "@/views/PageNotFound.vue";
import { AppRoute, AppRouteNames } from "./constants";

export const routes = [
    ...publicRoutes,
    ...privateRoutes,
    {
        path: AppRoute.PAGE_NOT_FOUND,
        name: AppRouteNames.PAGE_NOT_FOUND,
        component: PageNotFound as RouteComponent
    }
] as const;
